<template>
	<section id="app-main">
		<levelbar v-if="notLogin" />
		<router-view ref="main" />
	</section>
</template>

<script>
	import Levelbar from './Levelbar.vue';

	export default {
		name: 'AppMain',
		components: { Levelbar },
		computed: {
			notLogin() {
				return this.$route.name && this.$route.name !== 'Login';
			},
		},
	};
</script>

<style lang="scss" scoped>
	@import '~bulma/css/bulma.css';
	#app-main {
		overflow-x: auto;
		padding: 38px 40px 94px;

		@media (max-width: 768px) {
			padding: 38px 10px;
		}
	}
</style>
